import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // We definiëren targets, maar de toolbar target bestaat pas na injectie!
  static targets = ["input"]

  connect() {
    // We binden functies zodat 'this' verwijst naar de controller
    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)
    this.format = this.format.bind(this)
    this.changeSize = this.changeSize.bind(this)
  }

  show(e) {
    let element = e.target.closest('div')
    // Check of hij er al is (veiligheid)
    if (this.element.querySelector('.injected-toolbar')) return

    // 1. De HTML String voor de toolbar
    // Let op de data-action: we linken de klik direct aan deze controller
    const toolbarHTML = `
      <div class="injected-toolbar">
<input type="range" min="1" max="7" step="1" value="3"
               data-action="input->contenteditable#changeSize"
               title="Tekstgrootte">

        <button data-action="mousedown->contenteditable#format" data-command="bold">B</button>
        <button data-action="mousedown->contenteditable#format" data-command="italic">I</button>
        <button data-action="mousedown->contenteditable#format" data-command="underline">U</button>
      </div>
    `

    // 2. Injecteer de HTML vlak voor het input veld (maar binnen de controller div)
    element.insertAdjacentHTML('afterbegin', toolbarHTML)
  }

  hide(event) {
    // We gebruiken een kleine timeout. Waarom?
    // Als je focus verliest, is de toolbar misschien al weg voordat een klik registreert.
    // Echter, omdat we 'mousedown' met preventDefault gebruiken in format(),
    // is dit theoretisch niet nodig, maar het is een veilige fallback.

    const toolbar = this.element.querySelector('.injected-toolbar')
    if (toolbar) {
      //toolbar.remove()
    }
  }

  format(event) {
    // CRUCIAAL: Voorkom dat de button focus steelt van de tekst!
    // Als de tekst focus verliest, vuurt 'blur' en verdwijnt de toolbar.
    // Door preventDefault() blijft de focus op de tekst staan.
    event.preventDefault()
    event.stopPropagation()

    const command = event.target.dataset.command
    document.execCommand(command, false, null)
  }

  changeSize(event) {
    // Hier kunnen we geen preventDefault doen, want de slider moet bewegen.
    // Omdat de slider focus krijgt, vuurt de 'blur' op de tekst.
    // Daarom is de fix in de 'hide' functie hierboven zo belangrijk.

    const size = event.target.value

    // Omdat de focus nu op de slider staat, moeten we de tekst weer even 'aantikken'
    // voordat we het commando uitvoeren, anders weet de browser niet waar het moet gebeuren.
    // Echter, execCommand onthoudt vaak de selectie, laten we het proberen:

    document.execCommand("fontSize", false, size)
  }
}